module.exports = __webpack_public_path__ + "img/icons/icon-dossier.svg";